import Head from 'next/head';
import { useRouter } from 'next/router';

/**
 * Temporary component for adding fixed schema script to home page.
 *
 * @returns {JSX.Element}
 */

const HomePageHeader = () => {
  const router = useRouter();
  if (router.asPath !== '/' && !router.asPath.startsWith('/?')) return null;

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
          {
            "@context": "https://schema.org",
            "@type": "Corporation",
            "name": "Speakers Corner",
            "url": "https://www.speakerscorner.co.uk/",
            "logo": "https://cdn.speakerscorner.co.uk/convert/files/2021/06/2dc9aa80-d2a5-11eb-8e01-9dee4d4ba29a-SC%20Logo-screengrab.jpg/r%5Bwidth%5D=1280/2dc9aa80-d2a5-11eb-8e01-9dee4d4ba29a-SC%20Logo-screengrab.jpg",
            "sameAs": [
              "https://www.facebook.com/SpeakersCornerBureau?locale=en_GB",
              "https://www.instagram.com/speakerscornerbureau/?hl=en",
              "https://twitter.com/Speakers_Corner",
              "https://www.youtube.com/channel/UCmHmb4nfs9Dy_VPR88zl6Rw",
              "https://www.linkedin.com/company/speakers-corner/"
            ],
            "telephone": "+442076077070"
          }`
        }}
      />
    </Head>
  );
};

export default HomePageHeader;
